import { useSearchParams } from 'react-router'
import { RouterPath } from '@/router/paths'

export const LOGIN_REDIRECT_TO_PARAM = 'redirectTo'

export const useLoginRedirectTo = () => {
  const [searchParams] = useSearchParams()

  return searchParams.get(LOGIN_REDIRECT_TO_PARAM) ?? RouterPath.root
}
